// extracted by mini-css-extract-plugin
export default {"productList":"G2f513c"};